export default "__VITE_ASSET__BPqcTwSN__"